import { render } from "./ActiveFireCert.vue?vue&type=template&id=437872f7"
import script from "./ActiveFireCert.vue?vue&type=script&lang=js"
export * from "./ActiveFireCert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__